import { createFileRoute } from '@tanstack/react-router'
import { SITE_IMAGES } from '@/lib/site-images'

export const Route = createFileRoute('/product')({
  head: () => ({
    meta: [
      { title: 'Product — Halo Compliance' },
      {
        name: 'description',
        content:
          'AI-powered mortgage compliance review for sales, marketing, and compliance teams. Instant TILA, UDAAP, and RESPA feedback.',
      },
      { property: 'og:title', content: 'Product — Halo Compliance' },
      { property: 'og:url', content: 'https://www.halocompliance.com/product' },
    ],
    links: [{ rel: 'canonical', href: 'https://www.halocompliance.com/product' }],
  }),
  component: ProductPage,
})

function ProductPage() {
  return (
    <div className="marketing-inner pb-5">
      <div className="container-fluid px-0 mb-4 mb-md-5">
        <img
          src={SITE_IMAGES.product.heroAboveTitle}
          alt=""
          className="w-100 marketing-product-banner object-fit-cover"
          loading="eager"
          decoding="async"
        />
      </div>

      <div className="container py-4 pt-md-0">
        <div className="row justify-content-center mb-4 mb-md-5">
          <div className="col-lg-10 text-center">
            <h1 className="display-5 font-serif mb-4">Everyone pulling together</h1>
            <p className="lead text-body-secondary mb-0">
              Compliance, marketing and sales meeting the demands of the industry with speed and accuracy.
            </p>
          </div>
        </div>

        <div className="row g-4 row-cols-1 row-cols-md-3 pb-4">
          <Pillar
            title="Sales"
            body="Propel your sales team like never before. Halo gets your sales team their marketing collateral fast."
            imageSrc={SITE_IMAGES.product.pillarSales}
            imageAlt="Sales team collaboration"
          />
          <Pillar
            title="Marketing"
            body="Halo empowers your marketing team to innovate with instant compliance feedback."
            imageSrc={SITE_IMAGES.product.pillarMarketing}
            imageAlt="Marketing workspace"
          />
          <Pillar
            title="Compliance"
            body="AI-powered review saves your compliance team time and allows them to focus on the things that matter."
            imageSrc={SITE_IMAGES.product.pillarCompliance}
            imageAlt="Compliance review"
          />
        </div>
      </div>
    </div>
  )
}

function Pillar({
  title,
  body,
  imageSrc,
  imageAlt,
}: {
  title: string
  body: string
  imageSrc: string
  imageAlt: string
}) {
  return (
    <div className="col">
      <div className="card h-100 border-0 shadow-sm overflow-hidden marketing-pillar-card">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-100 marketing-pillar-img object-fit-cover"
          loading="lazy"
          decoding="async"
        />
        <div className="card-body p-4 p-lg-5">
          <h2 className="h4 font-serif text-warning mb-3">{title}</h2>
          <p className="mb-0 text-body-secondary lh-lg">{body}</p>
        </div>
      </div>
    </div>
  )
}
